import { Injectable } from '@angular/core';
import { Employee } from '../model/employee/employee';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { PageEmployee } from '../model/page-employee';
import { EnregistrerSignature } from '../model/employee/enregistrer-signature';
import { UpdateEmployee } from '../model/employee/update-employee';
import { CreateEmployee } from '../model/employee/create-employee';
import { ChangerPassword } from '../model/employee/changer-password';

@Injectable({
  providedIn: "root"
})
export class EmployeeService {
  constructor(private _restClientService: RestClientService) {}

  getAllEmployeesByAgence(agence) {
    return this._restClientService.load<Employee[]>(
      "employee/employees-by-agence?agence=" + agence
    );
  }


  getAllEmployeesByCodeAgence(codeAgence) {
    return this._restClientService.load<Employee[]>(
      "employee/employees-by-code-agence/" + codeAgence
    );
  }

  getEmployeeByUsername(username) {
    return this._restClientService.load<Employee>(
      "employee/employee/" + username
    );
  }

  getEmployeeById(employeeId) {
    return this._restClientService.load<Employee>(
      "employee/employee-by-id/" + employeeId
    );
  }
  getCurrentEmployee() {
    return this._restClientService.load<Employee>("employee/current-employee");
  }

  getEmployeeByProfile(profile) {
    return this._restClientService.load<Employee[]>(
      "employee/employees-by-profile/" + profile
    );
  }
  
  getAllEmployees() {
    return this._restClientService.load<Employee[]>("employee/employees");
  }

  getEmployeesAllege() {
    return this._restClientService.load<Employee[]>("employee/employees-allege");
  }

  getEmployeePageable(filter, page, size) {
    return this._restClientService.load<PageEmployee>(
      "employee/employee-pageable?filter=" +
        filter +
        "&page=" +
        page +
        "&size=" +
        size
    );
  }

  enregistrerSignature(enregistrerSignature: EnregistrerSignature) {
    return this._restClientService.put<EnregistrerSignature>(
      "employee/enregistrer-signature",
      enregistrerSignature
    );
  }

  update(updateEmployee: UpdateEmployee) {
    return this._restClientService.put<Employee>(
      `employee/update-employee`,
      updateEmployee
    );
  }

  add(createEmployee: CreateEmployee) {
    return this._restClientService.save<Employee>(
      "employee/add-employee",
      createEmployee
    );
  }

  changerAgence(changerAgence) {
    return this._restClientService.put<Employee>(
      `employee/changer-agence`,
      changerAgence
    );
  }

  desactiver(desactiverAgence) {
    return this._restClientService.put<Employee>(
      `employee/desactiver-employee`,
      desactiverAgence
    );
  }

  changerPassword(changerPassword: ChangerPassword) {
    return this._restClientService.put<void>(
      "employee/changer-password",
      changerPassword
    );
  }
}      

    